module.exports = __webpack_public_path__ + "static/media/page3-cattle.7603bcf7.png";